import AxiosInstance from "../services/networkServices";

/**
 * Fetch in-progress matches with rank/age summary.
 * @param {Object} params - { page, limit, rank, matchType, sortOrder, includeWeightBuckets }
 * Empty-string filters are omitted so the backend validator doesn't reject them.
 */
export const getInProgressMatches = async (params = {}) => {
  const query = Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) => value !== undefined && value !== null && value !== ""
    )
  );
  const res = await AxiosInstance.get("/admin/in-progress-matches", {
    params: query,
  });
  return res.data;
};

/**
 * Fetch the matchmaking pool (posts searching for an opponent) with
 * rank/wait-time summary.
 * @param {Object} params - { page, limit, rank, postType, sortOrder }
 * Empty-string filters are omitted so the backend validator doesn't reject them.
 */
export const getSearchingPosts = async (params = {}) => {
  const query = Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) => value !== undefined && value !== null && value !== ""
    )
  );
  const res = await AxiosInstance.get("/admin/searching-posts", {
    params: query,
  });
  return res.data;
};
